import React, { useRef, useMemo, useContext } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography } from '@material-ui/core';
import { UserContext } from '../../../../core/context/user';

const useStyles = makeStyles(() => ({
    editorContainerLight: {
        '& .quill': {
            backgroundColor: '#fff !important',
        },
        '& .ql-toolbar.ql-snow': {
            backgroundColor: '#f5f5f5 !important',
            borderColor: '#ccc !important',
            borderRadius: '4px 4px 0 0 !important',
            border: '1px solid #ccc !important',
        },
        '& .ql-container.ql-snow': {
            backgroundColor: '#fff !important',
            borderColor: '#ccc !important',
            borderRadius: '0 0 4px 4px !important',
            minHeight: '150px !important',
            fontSize: '16px !important',
            border: '1px solid #ccc !important',
        },
        '& .ql-editor': {
            minHeight: '150px !important',
            color: '#000 !important',
            backgroundColor: '#fff !important',
        },
        '& .ql-editor.ql-blank::before': {
            color: '#aaa !important',
            fontStyle: 'normal !important',
        },
        '& .ql-snow .ql-toolbar button': {
            color: '#444 !important',
            '&:hover': {
                color: '#FE6502 !important',
                backgroundColor: 'rgba(254, 101, 2, 0.05) !important',
            },
        },
        '& .ql-snow .ql-toolbar button.ql-active': {
            color: '#FE6502 !important',
            backgroundColor: 'rgba(254, 101, 2, 0.1) !important',
        },
        '& .ql-snow.ql-toolbar .ql-stroke': {
            stroke: '#444 !important',
        },
        '& .ql-snow.ql-toolbar button:hover .ql-stroke': {
            stroke: '#FE6502 !important',
        },
        '& .ql-snow.ql-toolbar button.ql-active .ql-stroke': {
            stroke: '#FE6502 !important',
        },
        '& .ql-snow.ql-toolbar .ql-fill': {
            fill: '#444 !important',
        },
        '& .ql-snow.ql-toolbar button:hover .ql-fill': {
            fill: '#FE6502 !important',
        },
        '& .ql-snow.ql-toolbar button.ql-active .ql-fill': {
            fill: '#FE6502 !important',
        },
        '& .ql-snow.ql-toolbar .ql-picker': {
            color: '#444 !important',
        },
        '& .ql-snow .ql-picker-options': {
            backgroundColor: '#fff !important',
            borderColor: '#ccc !important',
            border: '1px solid #ccc !important',
        },
        '& .ql-snow .ql-picker-item': {
            color: '#000 !important',
        },
        '& .ql-snow .ql-picker-label': {
            color: '#444 !important',
            '&:hover': {
                color: '#FE6502 !important',
            },
        },
        '& .ql-snow .ql-picker-label.ql-active': {
            color: '#FE6502 !important',
        },
        '& .ql-snow .ql-picker-label .ql-stroke': {
            stroke: '#444 !important',
        },
        '& .ql-toolbar .ql-formats': {
            marginRight: '15px !important',
        },
    },
    editorContainerDark: {
        '& .quill': {
            backgroundColor: '#2d2d2d !important',
        },
        '& .ql-toolbar.ql-snow': {
            backgroundColor: '#1e1e1e !important',
            borderColor: '#3d3d3d !important',
            borderRadius: '4px 4px 0 0 !important',
            border: '1px solid #3d3d3d !important',
        },
        '& .ql-container.ql-snow': {
            backgroundColor: '#2d2d2d !important',
            borderColor: '#3d3d3d !important',
            borderRadius: '0 0 4px 4px !important',
            minHeight: '150px !important',
            fontSize: '16px !important',
            border: '1px solid #3d3d3d !important',
        },
        '& .ql-editor': {
            minHeight: '150px !important',
            color: '#e0e0e0 !important',
            backgroundColor: '#2d2d2d !important',
        },
        '& .ql-editor.ql-blank::before': {
            color: '#7a7a7a !important',
            fontStyle: 'normal !important',
        },
        '& .ql-snow .ql-toolbar button': {
            color: '#b0b0b0 !important',
            '&:hover': {
                color: '#FE6502 !important',
                backgroundColor: 'rgba(254, 101, 2, 0.1) !important',
            },
        },
        '& .ql-snow .ql-toolbar button.ql-active': {
            color: '#FE6502 !important',
            backgroundColor: 'rgba(254, 101, 2, 0.15) !important',
        },
        '& .ql-snow.ql-toolbar .ql-stroke': {
            stroke: '#b0b0b0 !important',
        },
        '& .ql-snow.ql-toolbar button:hover .ql-stroke': {
            stroke: '#FE6502 !important',
        },
        '& .ql-snow.ql-toolbar button.ql-active .ql-stroke': {
            stroke: '#FE6502 !important',
        },
        '& .ql-snow.ql-toolbar .ql-fill': {
            fill: '#b0b0b0 !important',
        },
        '& .ql-snow.ql-toolbar button:hover .ql-fill': {
            fill: '#FE6502 !important',
        },
        '& .ql-snow.ql-toolbar button.ql-active .ql-fill': {
            fill: '#FE6502 !important',
        },
        '& .ql-snow.ql-toolbar .ql-picker': {
            color: '#b0b0b0 !important',
        },
        '& .ql-snow .ql-picker-options': {
            backgroundColor: '#2d2d2d !important',
            borderColor: '#3d3d3d !important',
            border: '1px solid #3d3d3d !important',
        },
        '& .ql-snow .ql-picker-item': {
            color: '#e0e0e0 !important',
        },
        '& .ql-snow .ql-picker-label': {
            color: '#b0b0b0 !important',
            '&:hover': {
                color: '#FE6502 !important',
            },
        },
        '& .ql-snow .ql-picker-label.ql-active': {
            color: '#FE6502 !important',
        },
        '& .ql-snow .ql-picker-label .ql-stroke': {
            stroke: '#b0b0b0 !important',
        },
        '& .ql-toolbar .ql-formats': {
            marginRight: '15px !important',
        },
    },
    editorError: {
        '& .ql-container': {
            borderColor: '#B32222',
        },
    },
    editorDisabled: {
        opacity: 0.6,
        pointerEvents: 'none',
    },
    errorText: {
        color: '#B32222',
        fontSize: '0.75rem',
        marginTop: '3px',
        marginLeft: '14px',
    },
}));

interface RichTextEditorProps {
    value: string;
    onChange: (value: string) => void;
    onFocus?: () => void;
    onBlur?: () => void;
    placeholder?: string;
    disabled?: boolean;
    error?: boolean;
    helperText?: string;
    maxLength?: number;
}

export const RichTextEditor: React.FC<RichTextEditorProps> = ({
    value,
    onChange,
    onFocus,
    onBlur,
    placeholder = '',
    disabled = false,
    error = false,
    helperText = '',
    maxLength,
}) => {
    const classes = useStyles();
    const userContext = useContext(UserContext);
    const quillRef = useRef<ReactQuill>(null);

    const modules = useMemo(
        () => ({
            toolbar: [
                [{ header: [1, 2, 3, false] }],
                ['bold', 'italic', 'underline', 'strike'],
                [{ list: 'ordered' }, { list: 'bullet' }],
                [{ indent: '-1' }, { indent: '+1' }],
                ['link'],
                ['clean'],
            ],
        }),
        []
    );

    const formats = [
        'header',
        'bold',
        'italic',
        'underline',
        'strike',
        'list',
        'bullet',
        'indent',
        'link',
    ];

    const handleChange = (content: string): void => {
        if (maxLength) {
            const quill = quillRef.current?.getEditor();
            if (quill) {
                const text = quill.getText();
                if (text.length > maxLength) {
                    // Prevent exceeding max length
                    return;
                }
            }
        }
        onChange(content);
    };

    return (
        <Box
            className={`${
                userContext.lightTheme ? classes.editorContainerLight : classes.editorContainerDark
            } ${error ? classes.editorError : ''} ${disabled ? classes.editorDisabled : ''}`}
        >
            <ReactQuill
                ref={quillRef}
                theme="snow"
                value={value}
                onChange={handleChange}
                onFocus={onFocus}
                onBlur={onBlur}
                modules={modules}
                formats={formats}
                placeholder={placeholder}
                readOnly={disabled}
            />
            {helperText && (
                <Typography className={classes.errorText}>{helperText}</Typography>
            )}
        </Box>
    );
};

